import { ConfirmDialog } from "../../ui";

type DeleteTeamDialogProps = {
  teamName: string;
  isOpen: boolean;
  onDelete: () => void;
  onClose: (update?: boolean) => void;
};

const DeleteTeamDialog = (props: DeleteTeamDialogProps) => (
  <ConfirmDialog
    open={props.isOpen}
    onClose={(confirmed) => props.onClose(confirmed || undefined)}
    // Fire-and-forget as before: the page runs the delete and reports the result itself.
    onConfirm={() => {
      props.onDelete();
    }}
    title="Are you sure?"
    message="This action cannot be undone. If you delete this team, you will lose all its data."
    confirmLabel="Delete"
  />
);

export default DeleteTeamDialog;
